import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { NavigationEnd, Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { BackendApiService } from 'src/app/service/backendapi.service';
import { EndpointsService } from 'src/app/service/endpoints.service';
import { InitiateTarriffComponent } from '../dialog/initiate-tarriff/initiate-tarriff.component';
import { HPMNCountry } from '../model/HPMNCountry';
import { HPMNNetwork } from '../model/HPMNNetwork';
import { DataService } from '../service/data.service';

@Component({
  selector: 'app-tarriff',
  templateUrl: './tarriff.component.html',
  styleUrls: ['./tarriff.component.scss']
})
export class TarriffComponent implements OnInit {
  tarriffForm: FormGroup;
  loadPage: boolean;
  tarriffData: [];
  tarriffData1: [];
  tarriffData2: [];
  showTable: boolean;
  startDate: any;
  endDate: any;
  mySubscription: any;
  affiliateData: any;
  // callVPMNNetwork: boolean;
  vpmnNetworkData: any;
  isSuperUser: boolean;

  constructor(private dataService: DataService, private formBuilder: FormBuilder, private spinnerService: Ng4LoadingSpinnerService,
    private router: Router, private endpointsService: EndpointsService,
    private backendApiService: BackendApiService, private dialog: MatDialog) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;

    this.mySubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Trick the Router into believing it's last link wasn't previously loaded
        this.router.navigated = false;
        window.scrollTo(0, 0);
      }
    });
  }
  
  ngOnInit(): void {
    this.isSuperUser = Boolean(sessionStorage.getItem("isSuperUser")==="true");
    this.spinnerService.show();
    this.createTarriffForm();
    this.getApiOnLoad();
    this.spinnerService.hide();
    this.loadPage = true;
  }

  createTarriffForm() {
    this.tarriffForm = this.formBuilder.group({
      vpmnCountry: ['ALL'],
      vpmnNetwork: ['ALL'],
      startDate: [''],
      endDate: ['']
    });
  }

  async getApiOnLoad() {
    this.spinnerService.show();
    const apiUrl = this.endpointsService.COUNTRY_DETAILS + '&userName=' + sessionStorage.getItem('ecowas_user_name');
    this.backendApiService.callToApi(apiUrl).subscribe(response => {
      this.tarriffData1 = response;
    });
  }

  getVpmnNetworkAccordingToCountry(event: any) {
    if (event.target.value === 'ALL') {
      // this.callVPMNNetwork = false;
      this.tarriffForm.controls.vpmnNetwork.setValue('ALL', { onlySelf: true });
    } else {
      this.getVpmnNetworkList(event.target.value).then();
    }
  }

  async getVpmnNetworkList(country: string) {
    const apiUrl1 = this.endpointsService.URL_GET_OPERATOR_LIST_BY_COUNTRY +
      '&userName=' + sessionStorage.getItem('ecowas_user_name') + '&country=' + country;
    this.backendApiService.callToApi(apiUrl1).subscribe(response => {
      this.tarriffData2 = response;
      if (this.tarriffData2 && this.tarriffData2.length > 0) {
        this.tarriffForm.controls.vpmnNetwork.setValue(response[0].operator, { onlySelf: true });
      }

    });
  }

  get f() {
    return this.tarriffForm.controls;
  }

  ngOnDestroy() {
    if (this.mySubscription) {
      this.mySubscription.unsubscribe();
    }
  }

  changeDateEvent(targetCalendarId: any) {
    targetCalendarId.toggle();
  }

  addNew() {
    const dialogRef = this.dialog.open(InitiateTarriffComponent, {
      width: '900px',
      panelClass: 'custom-modalbox',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      
      if (result === true) {
        // this.refreshTableData.emit();
      }
    });
  }

  onSearch() {
    const startDateFrom = this.tarriffForm.get('startDate').value;
    const endDateTo = this.tarriffForm.get('endDate').value;
    if (startDateFrom && endDateTo) {
      const dateFrom = new Date();
      dateFrom.setDate(startDateFrom.day);
      dateFrom.setMonth(startDateFrom.month - 1);
      dateFrom.setFullYear(startDateFrom.year);
      const dateTo = new Date();
      dateTo.setDate(endDateTo.day);
      dateTo.setMonth(endDateTo.month - 1);
      dateTo.setFullYear(endDateTo.year);
      if (dateTo.getTime() < dateFrom.getTime()) {
        alert('End date can\'t be less than Start date');
        return;
      }
      this.startDate = formatDate(dateFrom, 'yyyy-MM-dd', 'en');
      this.endDate = formatDate(dateTo, 'yyyy-MM-dd', 'en');
    }

    this.spinnerService.show();
    this.showTable = false;
    const apiUrl = this.endpointsService.URL_GET_TARRIFF + '&country=' +
      this.tarriffForm.get('vpmnCountry').value + '&network=' +
      this.tarriffForm.get('vpmnNetwork').value + '&userName=' +
      sessionStorage.getItem('ecowas_user_name') + '&userOrgId=' +
      sessionStorage.getItem('userOrgId');

    this.backendApiService.callToApi(apiUrl).subscribe(response => {
      if (response === null)
        return;

      this.tarriffData = response;
      this.showTable = true;
      this.spinnerService.hide();
    });
  }

  onReset() {
    this.spinnerService.show();
    this.showTable = false;
    this.createTarriffForm();
  }
}
